import React, { useEffect, useRef, useState } from 'react';
import Navigation from '../components/Navigation';
import Sidebar from '../components/Sidebar';
import base_url from '../config/Config';
import { NavLink, useLocation } from 'react-router-dom';
import { FaDownload } from "react-icons/fa";
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const NOC = () => {
    const [, setCustomer] = useState(null);
    const [loanMaster, setLoanMaster] = useState(null);
    const [partnerLoanId, setPartnerLoanId] = useState(null);
    const [, setLoan] = useState([]);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const id = params.get('id');


    const nocContentRef = useRef(null);

    useEffect(() => {
        const getOneCustomer = async () => {
            try {
                const response = await axios.get(`${base_url}/api1/account/verifiedCustomerById`, { params: { id } });
                console.log(response.data);
                setCustomer([response.data]); // Store customer data

                // Ensure partnerLoanId is set for subsequent use
                const partnerLoanIdFromAPI = response.data.partnerLoanId;
                setPartnerLoanId(partnerLoanIdFromAPI);
            } catch (error) {
                console.error("Error fetching Customer data:", error);
            }
        };

        if (id) {
            getOneCustomer();
        }
    }, [id]);

    // State for storing partnerLoanId
    // Fetch loan details using partnerLoanId
    useEffect(() => {
        if (partnerLoanId) {
            const getOneLoan = async () => {
                try {
                    const response = await axios.get(`${base_url}/api1/customer/disbursedByCustomerId`, {
                        params: { id, partnerLoanId }
                    });
                    console.log(response.data);
                    setLoan([response.data]);
                } catch (error) {
                    console.error("Error fetching Loan data:", error);
                }
            };

            getOneLoan();
        }
    }, [id, partnerLoanId]);

    useEffect(() => {
        const getOneLoanMaster = async () => {
            try {
                const response = await axios.get(
                    `${base_url}/api1/account/loanDetails?customerId=${id}&partnerLoanId=${partnerLoanId}`
                );
                setLoanMaster(response.data);
            } catch (error) {
                console.error("Error fetching Loan Details partner data:", error);
            }
        };


        getOneLoanMaster();

    }, [id, partnerLoanId]); // Include customer?.loanId in the dependency array


    const downloadPDF = async () => {
        const input = nocContentRef.current;

        if (input) {
            // Store the original background color
            const originalBackgroundColor = input.style.backgroundColor;
            // Temporarily remove the background color
            input.style.backgroundColor = 'transparent';

            // Adjust font size for better visibility
            input.style.fontSize = '16px';

            // Capture the content as an image with a lower scale for smaller size
            const canvas = await html2canvas(input, { scale: 1.5 });  // Adjust the scale as needed
            const imgData = canvas.toDataURL('image/jpeg', 1);  // Use JPEG with a quality of 0.7

            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 210; // A4 width in mm
            const pageHeight = 297; // A4 height in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            // Add extra space at the top and bottom
            const margin = 0; // Adjust this value to increase/decrease the margin
            // const topMargin = 20; // Adjust this value to increase/decrease the top margin
            // const bottomMargin = 20; // Adjust this value to increase/decrease the bottom margin
            // const contentHeight = pageHeight - topMargin - bottomMargin;

            let heightLeft = imgHeight;
            let position = margin;

            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight - margin * 2);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position = heightLeft - imgHeight + margin;
                pdf.addPage();
                pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight - margin * 2);
                heightLeft -= pageHeight;
            }

            // Save the PDF with minimum file size
            pdf.save('noc_certificate.pdf', { returnPromise: true }).then(() => {
                // Restore the original background color after PDF generation
                input.style.backgroundColor = originalBackgroundColor;
                // Restore original font size
                input.style.fontSize = '';
            });
        }
    };

    return (
        <>
            <div className='overviewsaa'>
                <h4>NOC Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5'>
                            <div className='row'>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='reportsanalyzier text-center mb-3'>
                                        <div className='row'>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='credit buttonandly'>
                                                    <NavLink to={`/headerfile/CreditReport?id=${id}`}><p>Credit Report</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='analyzier buttonandly'>
                                                    <NavLink to={`/headerfile/LoanAgreement?id=${id}`}><p>Loan Agreement</p></NavLink>
                                                </div>
                                            </div>
                                            {/* <div className='col-lg-2 col-md-2'>
                                                <div className='digitalfoot buttonandly'>
                                                    <NavLink to={`/headerfile/LoanProduct?id=${id}`}><p>Loan Product</p></NavLink>
                                                </div>
                                            </div> */}
                                            <div className='col-lg-2 col-md-3'>
                                                <div className='devicehistory buttonandly'>
                                                    <NavLink to={`/loanmaster/LoanList?customerId=${id}`}> <p>Loan Details</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='location buttonandly'>
                                                    <NavLink to={`/document/LoanDocuments?customerId=${id}`}> <p>Document</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='location buttonandly'>
                                                    <NavLink to={`/operation/ViewVerifiedCustomer?id=${id}`}><p>Customer View</p></NavLink>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-md-2'>
                                                <div className='businessverification buttonandly'>
                                                    <NavLink to={`/headerfile/NOC?id=${id}`}><p>NOC</p></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-lg-12 col-md-12'>
                                    <div className='pdfdownload'>
                                        <span onClick={downloadPDF}><FaDownload /> NOC</span>
                                    </div>
                                    <div className='noccertificate mb-5' ref={nocContentRef}>
                                        <div className='nocsection mt-2'>
                                            <h2>No Objection Certificate</h2>
                                        </div>
                                        <p>To</p>
                                        <p><strong>{loanMaster?.borrowerName || "Customer Name"}</strong></p>
                                        <p>Clients contact no: <strong>{loanMaster?.mobileNumber || "Customer Contact"}</strong></p>
                                        <p>CIN:<strong>U72900MH1999PLC122849</strong></p>
                                        <p><strong>Subject:</strong> Clearance of Personal Loan (Digital Loan)</p>
                                        <p>This is to certify that <strong>{loanMaster?.borrowerName || "Customer Name"}</strong> is our customer and has settled personal loan against loan Id <strong>{loanMaster?.partnerLoanId || "Loan ID"}</strong> of rupee <strong>{loanMaster?.loanAmount || "Loan Amount"}</strong> and final with <strong>{loanMaster?.partnerName || "Fintech Name"}</strong>  (UJJAWAL SRIJAN SOLUTION FOUNDATION).</p>
                                        <p>We further confirm that no outstanding payment is due and payable by the customer as of date against the said finance facility loan in our books.</p>
                                        <p>Please note that this certificate does not constitute any financial undertaking /liability and is being issued without any risk and responsibility on the part of the bank or any of its officers.</p>
                                        <p>Sincerely,</p>
                                        <p>Manager Operations</p>
                                        <p>UJJAWAL SRIJAN SOLUTION FOUNDATION</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NOC;
